import React from 'react';

import Header from './components/Header';
import Hero from './components/Hero';
import Steps from './components/Steps';
import City from './components/City';
import Posters from './components/Posters';
import Pricing from './components/Pricing';
import Faq from './components/Faq';
import Closing from './components/Closing';
import Footer from './components/Footer';
import { useLanguage } from './i18n';

const App = () => {
  const { t } = useLanguage();

  return (
    <>
      <a href='#main-content' className='skip-link'>
        {t.skipLink}
      </a>
      <Header />
      <main id='main-content' tabIndex={-1} className='focus:outline-none'>
        <Hero />
        <Steps />
        <City />
        <Posters />
        <Pricing />
        <Faq />
        <Closing />
      </main>
      <Footer />
    </>
  );
};

export default App;
